import { connect, ConnectedProps } from "react-redux";
import React from "react";
import { FilterOptions } from "./ChainParentFilter";
import { State } from "../state";
import SelectDropdown from "../components/SelectDropdown";
import zIndex from "@material-ui/core/styles/zIndex";
import Constants from "helpers/constants";

export interface Role {
  id: number;
  role: string;
}
interface RoleFilterFilterOwnProps {
  dataQa?: string;
  value?: number | null;
  roles: Role[];
  onChange: (options: FilterOptions) => any;
  isSearchable?: boolean;
  options: any;
  reset?: boolean;
}
interface RoleFilterState {
  currentId: any;
}

type RolesFilterProps = RoleFilterFilterOwnProps & PropsFromRedux;

class RoleFilter extends React.Component<RolesFilterProps, RoleFilterState> {
  state: RoleFilterState = {
    currentId: this.props.value ?? null,
  };
  componentDidUpdate(prevProps: RoleFilterFilterOwnProps) {
    if (prevProps.value !== this.props.value) {
      this.setState({ currentId: this.props.value ?? null });
    }
    // reset from parent
    if (this.props.reset && prevProps.reset !== this.props.reset) {
      this.setState({ currentId: null });
    }
  }

  public render() {
    const { roles, onChange, isSearchable, options, value } = this.props;
    const { currentId } = this.state;
    if (!roles) {
      return null;
    }
    const dropdownOptions = [{ value: -1, label: "Select Role" }].concat(
      options?.filter((option: any) => option.role !== Constants.AB_SYSTEM_ADMIN)?.map((chain: any) => {
        const chainName = chain.role;
        return {
          "data-qa": chainName,
          value: chain.id,
          label: chainName,
        };
      })
    );

    return (
      <div style={{ position: "relative", zIndex: 9999 }}>
        <SelectDropdown
          dataQa={this.props.dataQa}
          value={dropdownOptions.find((option) => option.value === currentId)}
          containerStyles={{
            marginLeft: "unset",
            // background: "white",
            fontWeight: "normal",
            boxShadow: "none",
            // backgroundColor: "transparent",
            zIndex: 999,
          }}
          options={dropdownOptions}
          onChange={(selected: any) => {
            this.setState({ currentId: selected.value }, () => {
              if (onChange) {
                onChange({
                  id: this.state.currentId,
                  name: selected.label,
                });
              }
            });
          }}
          placeholder="Select Role"
          isSearchable={isSearchable}

        />
      </div>
    );
  }
}
const connecter = connect((state: State) => ({
  roles: [],
}));
type PropsFromRedux = ConnectedProps<typeof connecter>;

export default connecter(RoleFilter);
